import { Box, Button, MenuItem, Select, Typography } from "@material-ui/core";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";

const TablePaginationControls = ({
	                         pageSize,
	                         handlePageSizeChange,
	                         getPage,
	                         goToPrevPage,
	                         goToNextPage,
	                         nextPageToken,
}: {
	pageSize: number,
	handlePageSizeChange: (pageSize: number) => void,
	getPage: () => number,
	goToPrevPage: () => void,
	goToNextPage: () => void,
	nextPageToken: string,
}) => {
	return (
		<Box display="flex" justifyContent="space-between" alignItems="center" p={2}>
			<Box display="flex" flexDirection="row" alignItems="center">
				<Typography variant="body2">
					Rows per page:
				</Typography>
				<Box pl={2}>
					<Select
						value={pageSize}
						onChange={(e) => {
							handlePageSizeChange(Number(e.target.value));
						}}
					>
						<MenuItem value={1}>1</MenuItem>
						<MenuItem value={5}>5</MenuItem>
						<MenuItem value={10}>10</MenuItem>
						<MenuItem value={25}>25</MenuItem>
					</Select>
				</Box>
			</Box>
			<Box>
				<Button
					disabled={getPage() === 0}
					onClick={() => goToPrevPage()}
					startIcon={<ArrowBackIcon />}
				>
					Previous
				</Button>
				<Typography component="span" style={{ margin: "0 16px" }}>
					Page {getPage() + 1}
				</Typography>
				<Button
					disabled={!nextPageToken || nextPageToken === ""}
					onClick={() => goToNextPage()}
					endIcon={<ArrowForwardIcon />}
				>
					Next
				</Button>
			</Box>
		</Box>
	);
};

export default TablePaginationControls;
